export enum DiscountType {
  Percent = "Percent",
  Amount = "Amount",
}

export interface Discount {
  id: number;
  reason: string;
  type: DiscountType;
  amount: number;
  order: number;
  autoFocus?: boolean | null;
}
